import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Security from '../../commons/security/Security.js'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import moment from 'moment'
import 'moment/min/locales'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-dropzone-component/styles/filepicker.css'
import 'dropzone/dist/min/dropzone.min.css'
import '../../assets/css/vec-dropzone.css'
import {FormattedMessage, injectIntl} from 'react-intl';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import { ITEM_TIPO_PRODUCTO, ITEM_TIPO_MANO_DE_OBRA } from '../../commons/constants/itemsTipos.js'
import backendStrings from '../../lang/backendStrings.js';
import swal from 'sweetalert'
import {
	camposObligatoriosFaltantes,
	obligatoriosCierre,
	CAMPOS_VALIDABLES_CIERRE_ITEMS,
	CAMPOS_VALIDABLES_CIERRE_TAREAS
} from "../presupuestoDetallado/obligatoriosPresupuesto.js";
import PresupuestoDetalladoItemGrid from "../presupuestoDetallado/PresupuestoDetalladoItemGrid.js";
import PresupuestoDetalladoTareaGrid from "../presupuestoDetallado/PresupuestoDetalladoTareaGrid.js";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

class TicketTareasItemsCierre extends Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.ajaxHandler = new AjaxHandler();
		let mdo = this.props.ticket.manoDeObra ? this.props.ticket.manoDeObra : '';
		let repuestos = this.props.ticket.repuestos ? this.props.ticket.repuestos : 0;
		let impuestos =  this.props.ticket.impuestos ?  this.props.ticket.impuestos : 0;
		let otros = this.props.ticket.otros ? this.props.ticket.otros : 0;
		moment.locale('es');

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				tareas: [],
				items: [],
				manoDeObra: mdo,
				impuestos: impuestos,
				repuestos: repuestos,
				otros: otros
			},
			maxLimitMonto: false,
			maxLimitObra: false,
			montosRepuesto: false,
			montosManoDeObra: false,
			listaSelectServicio: [],
			listaSelectTareas: [],
			listaSelectItems: [],
			servicioTareaSeleccionado: null,
			servicioItemSeleccionado: null,
			servicioSeleccionado: null,
			tareasSeleccionadas: [],
			errors: [],
			loading: false,
			tareasDisabled: true,
			tareasIsLoading: false,
			itemsDisabled: true,
			itemsIsLoading: false,
			totalRepuestos :0,
			totalManoDeObra: 0,
			isFormComplete: false,
			showTareas: [],
			enabledItems: false,
			showCierreItems: [],
			showCierreTareas: [],
			items: [],
			tareas: [],
			total: 0,
			detalleItemTemporal: '',
			clasificaciones: [],
			clasificacionItemTemporal: null,
			// VEC-3779: lista y selección propias del box de Mano de Obra. Solo se usan con
			// trabajaConManoDeObra ON, donde la MO son ítems; con el flag OFF ese box es el de tareas.
			clasificacionesManoObra: [],
			clasificacionItemMOTemporal: null,
			trabajaConManoDeObra: ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true',
			itemsManoDeObra: [],
			listaSelectItemsMO: [],
			servicioItemMOSeleccionado: null,
			itemsMOSeleccionadas: [],
			itemsMODisabled: true,
			itemsMOIsLoading: false,
			totalManoDeObraItems: 0
		};

		this.handleServicioChange = this.handleServicioChange.bind(this);
		this.handleTareasChange = this.handleTareasChange.bind(this);
		this.handleItemsChange = this.handleItemsChange.bind(this);
		this.handleDeleteTarea = this.handleDeleteTarea.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleCheckControlTotalItems = this.handleCheckControlTotalItems.bind(this);
		this.handleModalCheck = this.handleModalCheck.bind(this);
		this.calculateTotal = this.calculateTotal.bind(this);
		this.deleteServicioItem = this.deleteServicioItem.bind(this);
		this.addItem = this.addItem.bind(this);
		this.setLoadingAndUpdate = this.setLoadingAndUpdate.bind(this);
		this.updateServicioItem = this.updateServicioItem.bind(this);
		this.handleFormChangeImpuestos = this.handleFormChangeImpuestos.bind(this);
		this.handleFormChangeOtros = this.handleFormChangeOtros.bind(this);
		this.deleteServicioTarea = this.deleteServicioTarea.bind(this);
		this.updateTarea = this.updateTarea.bind(this);
		this.handleCheckControlTotalTareas = this.handleCheckControlTotalTareas.bind(this);
		this.handleItemsMOChange = this.handleItemsMOChange.bind(this);
		this.loadItemsMO = this.loadItemsMO.bind(this);
		this.handleAddItemMO = this.handleAddItemMO.bind(this);
		this.deleteItemMO = this.deleteItemMO.bind(this);
		this.addItemMOFromGrid = this.addItemMOFromGrid.bind(this);
		this.updateItemMO = this.updateItemMO.bind(this);

	}

	componentDidMount() {
		if(Security.hasPermission('TICKETS_VER_TAREAS')) {
			this.ajaxHandler.subscribe(this);
			this.initForm();
		} else {
			this.setState({
				redirectTo: '/error'
			});
		}
	}

	initForm() {
		this.setState({ loading: true });
		let component = this;

		let enabledItems = ConfigBusiness.get('tickets.presupuesto.items.habilitado') === 'true';
		let showCierreItems = [];
		if(enabledItems){
			showCierreItems = ConfigBusiness.get('tickets.presupuesto.items.showCierre').split(',');
		}

		let enabledTareas = ConfigBusiness.get('tickets.presupuesto.tareas.habilitado') === 'true';
		let showCierreTareas = [];
		if(enabledTareas){
			showCierreTareas = ConfigBusiness.get('tickets.presupuesto.tareas.showCierre').split(',');
		}

		this.setState({ 
			enabledItems: enabledItems,
			enabledTareas: enabledTareas,
			showCierreItems: showCierreItems,
			showCierreTareas: showCierreTareas
		});

		if(enabledItems && showCierreItems.includes('clasificacion')){
			this.getClasificaciones();
		}

		// Determinar qué endpoint usar según si tiene abono o no
		let itemsTareasPromise;
		if (this.props.ticket.abono) {
			// Ticket CON abono: traer items y tareas de apertura
			itemsTareasPromise = Promise.all([
				this.ajaxHandler.getJson('/items/items-and-servicio-by-ticket/' + this.props.ticket.id + this.tarifarioCierreQS('')),
				this.ajaxHandler.getJson('/tareas/tareas-and-servicio-by-ticket/' + this.props.ticket.id)
			]).then(([itemsApertura, tareasApertura]) => {
				// Formatear para devolver estructura similar a presupuestos
				return {
					esAbono: true,
					items: itemsApertura || [],
					tareas: tareasApertura || []
				};
			});
		} else {
			// Ticket SIN abono: usar presupuestos
			itemsTareasPromise = this.ajaxHandler.getJson('/ticket-presupuestos/ticket/' + this.props.ticket.id + '/grid')
				.then(presupuestos => {
					return {
						esAbono: false,
						presupuestos: presupuestos
					};
				});
		}

		Promise.all([
			this.ajaxHandler.getJson('/servicios/tipo-ticket/' + this.props.ticket.ticketTipo + '/select'),
			this.ajaxHandler.getJson('/tickets/tareas/' + this.props.ticket.id ),
			ConfigBusiness.get('tickets.tareasCierre.montosRepuesto'),
			itemsTareasPromise
		]).then((data) => {
			let servicios = data[0];
			
			// Determinar si mostrar montos según configuraciones
			let tareasCierreGlobal = ConfigBusiness.get('tickets.tareasCierre.habilitado') === 'true';
			let tareasCierreConAbono = ConfigBusiness.get('tickets.conAbono.tareasCierre.habilitado') === 'true' && this.props.ticket.abono === true;
			
			// Si es config de abono, NO mostrar montos (funciona como montosRepuesto en false)
			// Si es config global, mostrar montos según la config montosRepuesto
			let montosRepuesto = false;
			if (tareasCierreGlobal) {
				montosRepuesto = data[2] == 'true';
			} else if (tareasCierreConAbono) {
				montosRepuesto = false; // Siempre false cuando es config de abono
			}
			
			let montosManoDeObra = false;
			let formDataCopy = this.state.formData
			let items = [];
			let tareas = [];

			let dataCierre = data[3];

			// Función helper para mapear items
			const mapearItems = (itemsArray, usarCostoEnVezDePrecio = false) => {
				return itemsArray.map((element, index) => {
					let precio = usarCostoEnVezDePrecio ? (element.costo || 0) : (element.precio || 0);
					let cantidad = element.cantidad || 1;
					let total = precio * cantidad;
					let servicio = {
						id: element.servicio_id,
						nombre: element.servicio_nombre || element.cuenta_mayor_descripcion
					}
					return {
						...element,
						id: element.id_item,
						descripcion: element.descripcion,
						index,
						costo: precio,
						cantidad: cantidad,
						servicio: servicio,
						total: total,
						clasificacion: element.clasificacion || '',
						// VEC-3779: el endpoint /ticket-presupuestos/ticket/{id}/grid selecciona
						// `presupuesto_items.*`, y la columna se llama `id_item_clasificacion`; el nombre
						// `id_clasificacion` solo existe en las filas que carga el usuario. Leer una sola
						// clave dejaba esto SIEMPRE en null para las filas precargadas, y como
						// setTareasItemsCierre inserta `item_clasificacion_id => $item['id_clasificacion']`,
						// cada cierre borraba la clasificación que traía el presupuesto.
						id_clasificacion: element.id_clasificacion || element.id_item_clasificacion || null,
						detalle: element.detalle || ''
					};
				});
			};

			// Función helper para mapear tareas
			const mapearTareas = (tareasArray, esApertura = false) => {
				return tareasArray.map((element, index) => {
					let precio = element.precio || 0;
					let cantidad = element.cantidad || 1;
					let total = precio * cantidad;
					let servicio = {
						id: element.servicio_id,
						nombre: element.servicio_nombre
					}
					return {
						...element,
						index,
						id: esApertura ? element.id : element.id_tarea,
						nombre: element.nombre,
						precio: precio,
						servicio: servicio,
						cantidad: cantidad,
						total: total
					};
				});
			};

			if (dataCierre.esAbono) {
				// CASO: Ticket CON abono - procesar items y tareas de apertura
				if (dataCierre.items && dataCierre.items.length > 0) {
					items = mapearItems(dataCierre.items, true); // true = usar 'costo' en vez de 'precio'
				}
				if (dataCierre.tareas && dataCierre.tareas.length > 0) {
					tareas = mapearTareas(dataCierre.tareas, true); // true = es de apertura
				}
			} else {
				// CASO: Ticket SIN abono - procesar desde presupuestos
				let presupuestos = dataCierre.presupuestos;
				if (presupuestos) {
					let presupuestoActivo = presupuestos.find(p => p.activo);
					if (presupuestoActivo) {
						if (presupuestoActivo.presupuestoRepuestos) {
							items = mapearItems(presupuestoActivo.presupuestoRepuestos, false);
						}
						if (presupuestoActivo.presupuestoManoObras) {
							tareas = mapearTareas(presupuestoActivo.presupuestoManoObras, false);
						}
					}
				}
			}
			let itemsManoDeObra = [];
			if (this.state.trabajaConManoDeObra) {
				let itemsProducto = [];
				items.forEach(function(item) {
					if (item.tipo && item.tipo.toLowerCase() === ITEM_TIPO_MANO_DE_OBRA.toLowerCase()) {
						itemsManoDeObra.push(item);
					} else {
						itemsProducto.push(item);
					}
				});
				items = itemsProducto;
			}
			this.calculateTotal(items, tareas, this.state.formData.impuestos, this.state.formData.otros, itemsManoDeObra);
			let aplicarServicios = (serviciosFinal) => {
				this.setState({
					formData: formDataCopy,
					servicios: serviciosFinal,
					montosRepuesto: montosRepuesto,
					montosManoDeObra: montosManoDeObra,
					items: items,
					tareas: tareas,
					itemsManoDeObra: itemsManoDeObra
				});
			};
			// VEC-2591: con la config activa, restringir los servicios de cierre a los del proveedor asignado.
			let serviciosProveedoresHabilitado = ConfigBusiness.get('servicios.proveedores.habilitado') === 'true';
			let gerenciadorId = this.props.ticket.gerenciador ? this.props.ticket.gerenciador.id : null;
			if (serviciosProveedoresHabilitado && gerenciadorId) {
				this.ajaxHandler.getJson('/gerenciadores/' + gerenciadorId + '/servicios/select?ticketTipo=' + this.props.ticket.ticketTipo)
					.then((provServicios) => {
						let permitidos = provServicios ? provServicios.map(function(s){ return s.value; }) : [];
						aplicarServicios((servicios || []).filter(function(s){ return permitidos.indexOf(s.value) !== -1; }));
					}).catch(() => aplicarServicios(servicios));
			} else {
				aplicarServicios(servicios);
			}
		}).catch(function(error) {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			component.setState({ loading: false });
		});
	}

	// VEC-3947: los ítems de cada servicio, solo los que brinda el proveedor del ticket (si tiene subconjunto).
	/**
	 * VEC-3499 — precios del tarifario con el que se cotizó el ticket (el guardado en su presupuesto),
	 * el mismo que valida el cierre en el backend. Detrás del flag: con Tarifarios apagado las URLs
	 * quedan idénticas.
	 */
	tarifarioCierreQS(url) {
		if (ConfigBusiness.get('tarifarios.habilitado') !== 'true' || !this.props.ticket || !this.props.ticket.id) return '';
		return (url.indexOf('?') === -1 ? '?' : '&') + 'ticketId=' + encodeURIComponent(this.props.ticket.id) + '&cierre=1';
	}

	proveedorItemsQS(url) {
		let gerenciador = this.props.ticket.gerenciador;
		if (ConfigBusiness.get('servicios.proveedores.habilitado') !== 'true' || !gerenciador) return '';
		return (url.indexOf('?') === -1 ? '?' : '&') + 'gerenciadorId=' + gerenciador.id;
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		this.setState({
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				tareas: []
			},
			maxLimitMonto: false,
			maxLimitObra: false,
			maxLimitImpuestos: false,
			maxLimitOtros: false,
			montosRepuesto: false,
			montosManoDeObra: false,
			listaSelectServicio: [],
			listaSelectTareas: [],
			servicioTareaSeleccionado: null,
			tareasSeleccionadas: [],
			itemsSeleccionadas: [],
			errors: [],
			loading: false,
			tareasDisabled: true,
			tareasIsLoading: false
		}, ()=>{
			this.formValidation.validate();
			this.props.callbackSave();
		});
	}

	handleServicioChange(object, name) {
		if(object) {
			if(name === "servicioTarea"){
				this.setState({
					servicioTareaSeleccionado: object,
					tareasIsLoading: true
				}, () => {
					this.ajaxHandler.getJson('/tareas/tareas-de-servicio/' + object.value)
					.then((data) => {
						let listaSelectTareas = data;
						this.setState({
							listaSelectTareas: listaSelectTareas,
							tareasDisabled: false,
							tareasIsLoading: false
						});
					}).catch(function(error) {
						AjaxHandler.handleError(error);
					});
				});
			} if (name === "servicioItem") {
				this.setState({
					servicioItemSeleccionado: object,
					itemsIsLoading: true
				}, () => {
					let urlItems = '/items/items-de-servicio/' + object.value;
					if (this.state.trabajaConManoDeObra) {
						urlItems += '?tipoItem=' + ITEM_TIPO_PRODUCTO;
					}
					urlItems += this.proveedorItemsQS(urlItems);
					urlItems += this.tarifarioCierreQS(urlItems);
					this.ajaxHandler.getJson(urlItems)
					.then((data) => {
						let listaSelectItems = data;
						this.setState({
							listaSelectItems: listaSelectItems,
							itemsDisabled: false,
							itemsIsLoading: false
						});
					}).catch(function(error) {
						AjaxHandler.handleError(error);
					});
				});
			} if (name === "servicioItemMO") {
				this.setState({
					servicioItemMOSeleccionado: object,
					itemsMOIsLoading: true
				}, () => {
					this.ajaxHandler.getJson('/items/items-de-servicio/' + object.value + '?tipoItem=' + encodeURIComponent(ITEM_TIPO_MANO_DE_OBRA) + this.proveedorItemsQS('?') + this.tarifarioCierreQS('?'))
					.then((data) => {
						this.setState({
							listaSelectItemsMO: data,
							itemsMODisabled: false,
							itemsMOIsLoading: false
						});
					}).catch(function(error) {
						AjaxHandler.handleError(error);
					});
				});
			} else {

			}
		} else {
			this.setState({
				servicioTareaSeleccionado: null,
				tareasSeleccionadas: [],
				tareasDisabled: true
			});
		}
	}

	handleTareasChange(value) {
		this.setState({
			tareasSeleccionadas: value
		});
	}

	handleItemsChange(value){
		this.setState({
			itemsSeleccionadas: value
		});
	}

	loadTareas(tareas) {
		let tareasCopy = JSON.parse(JSON.stringify(this.state.tareas));
		tareas.map((tarea)=>{
			if(tareasCopy.findIndex(x => x.id === tarea.id && x.servicio.id === tarea.servicio.id) === -1) {
				tareasCopy.push(tarea);
			}
			return tareas;
		});

		this.setState({
			tareas: tareasCopy,
			servicioTareaSeleccionado: null,
			tareasSeleccionadas: [],
			tareasDisabled: true
		});
		this.calculateTotal(this.state.items, tareasCopy, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalTareas(tareasCopy)
	}

	handleAddTarea() {
		let tareas = [];
		this.state.tareasSeleccionadas.map((tareaSeleccionada)=>{
			let tarea = {
				id: tareaSeleccionada.id,
				nombre: tareaSeleccionada.nombre,
				servicio: {
					id: this.state.servicioTareaSeleccionado.value,
					nombre: this.state.servicioTareaSeleccionado.label
				},
				precio: tareaSeleccionada.precio ? tareaSeleccionada.precio : 0,
				cantidad: 1,
				total: 0
			}
			tarea.total = tarea.precio * tarea.cantidad
			tareas.push(tarea);
		 return tareaSeleccionada;
		});
		this.loadTareas(tareas);
	}

	loadItems(items) {
		let itemsCopy = JSON.parse(JSON.stringify(this.state.items));
		items.map((item)=>{
			if(itemsCopy.findIndex(x => x.id === item.id && x.servicio.id === item.servicio.id) === -1) {
				itemsCopy.push(item);
			}
			return item;
		});

		this.setState({
			items: itemsCopy,
			servicioItemSeleccionado: null,
			itemsSeleccionadas: [],
			itemsDisabled: true,
			detalleItemTemporal: '',
			clasificacionItemTemporal: null
		});
		this.calculateTotal(itemsCopy, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalItems(itemsCopy)
	}

	handleAddItem() {
		let items = [];
		this.state.itemsSeleccionadas.map((itemSeleccionada)=>{
			let clasificacionNombre = '';
			let clasificacionId = null;
			if(this.state.clasificacionItemTemporal && this.state.clasificacionItemTemporal.nombre) {
				clasificacionNombre = this.state.clasificacionItemTemporal.nombre;
			}
			if(this.state.clasificacionItemTemporal && this.state.clasificacionItemTemporal.id) {
				clasificacionId = this.state.clasificacionItemTemporal.id;
			}
			let item = {
				id: itemSeleccionada.id,
				id_item: itemSeleccionada.id,
				tipo: itemSeleccionada.tipo,
				descripcion: itemSeleccionada.descripcion,
				detalle: this.state.detalleItemTemporal || '',
				clasificacion: clasificacionNombre,
				id_clasificacion: clasificacionId,
				costo_fijo: itemSeleccionada.costo_fijo,
				servicio: {
					id: this.state.servicioItemSeleccionado.value,
					nombre: this.state.servicioItemSeleccionado.label
				},
				costo: itemSeleccionada.costo ? itemSeleccionada.costo : 0,
				cantidad: itemSeleccionada.cantidad ? itemSeleccionada.cantidad : 0,
				total: 0
			};
			item.total = item.costo* item.cantidad
			items.push(item);
		 return itemSeleccionada;
		});
		this.loadItems(items);
	}

	handleCheckControlTotalItems(items){
		let total = 0;
		items.forEach(element => {
			total += parseFloat(element.total ? element.total : 0)
		});

		let repuestos = this.state.formData.repuestos;
		if(total > (repuestos)) {
			this.setState({
				maxLimitMonto: true
			});
		} else {
			this.setState({
				maxLimitMonto: false
			});
		}
	}

	handleCheckControlTotalTareas(tareas, itemsManoDeObraParam){
		let total = 0;
		tareas.forEach(element => {
			total += parseFloat(element.total ? element.total : 0)
		});

		if (this.state.trabajaConManoDeObra) {
			let itemsMdo = itemsManoDeObraParam !== undefined ? itemsManoDeObraParam : this.state.itemsManoDeObra;
			itemsMdo.forEach(element => {
				if (element.cantidad && element.costo) {
					total += element.cantidad * element.costo;
				}
			});
		}

		let manoDeObra = this.state.formData.manoDeObra;
		if(total > (manoDeObra)) {
			this.setState({
				maxLimitObra: true
			});
		} else {
			this.setState({
				maxLimitObra: false
			});
		}
	}

	handleCheckControlTotalManoDeObra(tareas){
		let totalManoDeObra = 0;
		tareas.forEach(element => {
			totalManoDeObra += parseFloat(element.mano_de_obra ? element.mano_de_obra : 0)
		});
		let mano_de_obra = this.state.props.ticket.manoDeObra;

		if(totalManoDeObra > (mano_de_obra)) {
			this.setState({
				maxLimitObra: true
			});
		} else {
			this.setState({
				maxLimitObra: false
			});
		}

		this.setState({totalManoDeObra: totalManoDeObra})
	}

	handleDeleteTarea(index) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.tareas.splice(index, 1);
		this.setState({
			formData: formDataCopy
		});
		this.handleCheckControlTotal(formDataCopy.tareas)
	}

	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
	}

	isFormCompleteCheck(){
		let tareas = this.state.formData.tareas
		const todosConValores = tareas.every(tarea => tarea.monto && tarea.mano_de_obra)
		this.setState({isFormComplete: todosConValores})
	}

	// VEC-3779: el filtrado de showCierre vivía inline en render(). Se extrae para poder validar contra
	// la MISMA lista que se muestra: con montosRepuesto en false los campos de monto no se renderizan, y
	// exigir uno que no se ve dejaría al usuario sin forma de destrabarse.
	getShowCierreFiltrado(clave) {
		let base = clave === 'tareas' ? this.state.showCierreTareas : this.state.showCierreItems;
		base = base || [];
		if (this.state.montosRepuesto) {
			return base;
		}
		let camposMontos = clave === 'tareas' ? ['precio', 'total'] : ['costo', 'total'];
		return base.filter(campo => !camposMontos.includes(campo));
	}

	// VEC-3779: campos obligatorios que el cierre puede exigir de verdad, cruzando la config de
	// obligatorios con lo que está visible y con la whitelist de campos editables acá.
	getObligatoriosCierre(clave) {
		let configKey = clave === 'tareas'
			? 'tickets.presupuesto.tareas.obligatorios'
			: 'tickets.presupuesto.items.obligatorios';
		let obligatorios = (ConfigBusiness.get(configKey) || '').split(',');
		let validables = clave === 'tareas' ? CAMPOS_VALIDABLES_CIERRE_TAREAS : CAMPOS_VALIDABLES_CIERRE_ITEMS;
		return obligatoriosCierre(obligatorios, this.getShowCierreFiltrado(clave), validables);
	}

	// Devuelve las keys i18n de los errores de obligatorios, o [] si está todo bien.
	validarObligatoriosCierre() {
		let faltantes = [];
		let obligatoriosItems = this.getObligatoriosCierre('items');
		if (obligatoriosItems.length) {
			let filasItems = this.state.trabajaConManoDeObra
				? this.state.items.concat(this.state.itemsManoDeObra)
				: this.state.items;
			faltantes = faltantes.concat(camposObligatoriosFaltantes(filasItems, obligatoriosItems));
		}
		// Las tareas solo se validan cuando su box está efectivamente renderizado. Con
		// trabajaConManoDeObra ON el grid de tareas no se muestra pero initForm igual las carga y
		// handleSubmit las manda: validarlas ahí trabaría el cierre por filas que el usuario no ve.
		if (!this.state.trabajaConManoDeObra) {
			let obligatoriosTareas = this.getObligatoriosCierre('tareas');
			if (obligatoriosTareas.length) {
				faltantes = faltantes.concat(camposObligatoriosFaltantes(this.state.tareas, obligatoriosTareas));
			}
		}
		return faltantes
			.filter((campo, i) => faltantes.indexOf(campo) === i)
			.map(campo => campo === 'clasificacion'
				? 'TicketTareasItemsCierre.errors.clasificacion_requerida'
				: 'TicketTareasItemsCierre.errors.cantidad_requerida');
	}

	handleModalCheck(event) {
		let component = this
		let totalIngresado = this.state.totalManoDeObra + this.state.totalRepuestos
		let totalPresupuestado = this.state.props.ticket.manoDeObra + this.state.props.ticket.repuestos

		// VEC-3779: validar ANTES del swal de "valores menores a lo presupuestado", si no el usuario
		// confirma ese diálogo y recién después ve el error. Y antes de que handleSubmit toque formData.
		let erroresObligatorios = this.validarObligatoriosCierre();
		if (erroresObligatorios.length > 0) {
			this.setState({ errors: erroresObligatorios });
			// El bloque .alert-danger vive al principio del modal, ~550 líneas de JSX por encima del botón
			// Guardar. Con el modal scrolleado hasta abajo (que es donde está el botón), el mensaje queda
			// fuera del viewport y el click parece no hacer nada. Por eso se avisa con swal —el mismo
			// patrón que ya usa PresupuestoDetalladoEditModal para estos mismos campos— y además se sube
			// el scroll para que el alert embebido quede a la vista.
			swal({
				title: this.props.intl.formatMessage({
					id: 'TicketTareasItemsCierre.errors.camposObligatorios',
					defaultMessage: 'Faltan datos obligatorios'
				}),
				text: erroresObligatorios
					.map(key => this.props.intl.formatMessage(backendStrings[key]))
					.join('\n'),
				icon: 'warning',
				button: { className: 'btn btn-primary' }
			});
			// El que scrollea no es la ventana ni el div del modal, sino el .modal-body que los envuelve
			// (tiene max-height + overflow por la clase modal-mh).
			let modalBody = document.querySelector('#tareas_cierre_modal .modal-body');
			if (modalBody) {
				modalBody.scrollTop = 0;
			}
			event.preventDefault();
			return;
		}

		if (totalIngresado < totalPresupuestado && this.state.montosRepuesto) {
			swal({
				title: this.props.intl.formatMessage({
					id: 'ticketTareasCierre.render.swal.valoresMenores',
					defaultMessage: 'La suma de los valores ingresados es menores a lo presupuestado'
				}),
				text: this.props.intl.formatMessage({
					id: 'ticketTareasCierre.render.swal.deseaContinuar',
					defaultMessage: '¿Desea continuar?'
				}),
				icon: "warning",
				buttons: [
					this.props.intl.formatMessage({
						id: 'ticketTareasCierre.render.swal.cancel',
						defaultMessage: 'Cancelar'}),
						this.props.intl.formatMessage({
							id: 'ticketTareasCierre.render.swal.continue',
							defaultMessage: 'Continuar'}),
				],
				dangerMode: true,
			}).then(function(isConfirm) {
				if (isConfirm) {
					component.handleSubmit(event);
				}
			});

		} else {
			component.handleSubmit(event);
		}

		event.preventDefault();
	}

	renderTableTheadTarea(field, index){
		switch (field) {
			case 'nombre':
				return (
					<th key={index} scope="col" style={{ maxWidth: "3px" }}>
						<FormattedMessage id="Presupuesto.Tareas" defaultMessage="Tareas" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'precio':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" />
					</th>
				);
			case 'total':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="Presupuesto.Total" defaultMessage="Total" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col">
						<FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" />
					</th>
				);
			default:
				return null;
		}
	}
																				
	renderTableTbodyTarea(element, field, index, index_tarea){
		switch (field) {
			case 'nombre':
				return (
					<td key={index} className="align-middle">
						{element.nombre}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="align-middle">
						<input
							type="number"
							className="form-control text-right pr-1"
							min="0"
							step="1"
							value={element.cantidad}
							onChange={(e) => this.handleChangeCantidadTarea(e,index_tarea)}
							onKeyDown={(e) => { if (['e', 'E', '+', '-', '.', ','].indexOf(e.key) !== -1) e.preventDefault(); }}
						/>
					</td>
				);
			case 'precio':
				return (
					<td key={index} className="align-middle">
						<input
							type="number"
							className="form-control text-right pr-1"
							min="0"
							step="0.01"
							value={element.precio}
							onChange={(e) => this.handleChangePrecioTarea(e,index_tarea)}
						/>
					</td>
				);
			case 'total':
				return (
					<td key={index} className="align-middle">
						{element.total}
					</td>
				);
			case 'servicio':
				return (
					<td key={index} className="align-middle">
						{element.servicio ? element.servicio.nombre : ''}
					</td>
				);
			default:
				return null;
		}
	}

	handleChangePrecioTarea(evt,index){
		let formDataCopy = this.state.formData
		formDataCopy.tareas[index].precio = evt.target.value
			let total = formDataCopy.tareas[index].precio &&
				formDataCopy.tareas[index].cantidad ? 
				('$ ' + Math.round((formDataCopy.tareas[index].precio*formDataCopy.tareas[index].cantidad)*100)/100) : ''
			formDataCopy.tareas[index].total = total
		this.setState({ formData: formDataCopy });
	}

	handleChangeCantidadTarea(evt,index){
		let formDataCopy = this.state.formData
		formDataCopy.tareas[index].cantidad = evt.target.value === '' ? '' : evt.target.value.split('.')[0]
			let total = formDataCopy.tareas[index].precio &&
				formDataCopy.tareas[index].cantidad ? 
				('$ ' + Math.round((formDataCopy.tareas[index].precio*formDataCopy.tareas[index].cantidad)*100)/100) : ''
			formDataCopy.tareas[index].total = total
		this.setState({ formData: formDataCopy });
	}

	handleSubmit(event) {
		// VEC-3779: no mutar this.state.formData in place. `formData.manoDeObra` / `.repuestos` son el
		// LÍMITE contra el que comparan handleCheckControlTotalTareas/Items para prender maxLimitObra y
		// maxLimitMonto. Pisarlos con los totales actuales antes de un early-return dejaba el límite
		// rebasado y esos guards dejaban de dispararse — justo los que protegen al presupuesto de ser
		// sobrescrito. Se arma una copia y el state solo se toca en la rama de éxito.
		let tareas = this.state.tareas;
		let items = this.state.trabajaConManoDeObra
			? this.state.items.concat(this.state.itemsManoDeObra)
			: this.state.items;
		let totalItemsCount = items.length;
		if((tareas && tareas.length > 0 ) || totalItemsCount > 0){
			let servicio = tareas[0] ? tareas[0].servicio : items[0].servicio;
			let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
			formDataCopy.tareas = JSON.parse(JSON.stringify(tareas));
			formDataCopy.items = JSON.parse(JSON.stringify(items));
			formDataCopy.manoDeObra = this.state.totalManoDeObra;
			formDataCopy.repuestos = this.state.totalRepuestos;
			formDataCopy.servicio = servicio;

			// Si no se usan montos (abono o config), enviar todos los montos en 0
			if (!this.state.montosRepuesto) {
				formDataCopy.tareas = formDataCopy.tareas.map(tarea => ({
					...tarea,
					cantidad: tarea.cantidad || 1,
					precio: 0,
					total: 0
				}));
				// VEC-3779: los ítems con costo_fijo = 1 se reenvían con SU costo, no con 0.
				// El backend valida que el monto fijo no cambie (TicketsService::listoParaRetirar) y esa
				// validación no exceptúa el modo sin montos, así que mandar 0 en uno de esos ítems devolvía
				// 400 "No se puede modificar el monto fijo del ítem ..." y el cierre fallaba. Venía fallando
				// en silencio porque TicketHeader nunca renderizaba el error.
				// No contradice la regla de Abono: el monto no se muestra ni se edita en la UI, y los totales
				// del ticket siguen yendo en 0, así que no impacta el presupuesto ni el consumo del abono.
				// Misma solución que ya aplica la app mobile (vecfleet-quasar, Commons/tareasCierre.js:
				// normalizarItemSinMontos), que documentó este mismo problema del lado web.
				formDataCopy.items = formDataCopy.items.map(item => {
					let esCostoFijo = Number(item.costo_fijo) === 1;
					let costo = esCostoFijo ? Math.round(Number(item.costo) * 100) / 100 : 0;
					return {
						...item,
						cantidad: item.cantidad || 1,
						costo: isNaN(costo) ? 0 : costo,
						total: 0
					};
				});
				formDataCopy.manoDeObra = 0;
				formDataCopy.repuestos = 0;
				formDataCopy.impuestos = 0;
				formDataCopy.otros = 0;
			}
			
			this.setState({
				formData: formDataCopy,
				loading: true
			},() =>{
				this.props.callbackSave(this.state.formData);
			});
		} else {
			// VEC-3779: arrancar de cero en cada intento. Antes se hacía push sobre el array del state,
			// así que cada reintento fallido duplicaba el mensaje en el alert.
			let errors = ['TicketTareasItemsCierre.errors.deber_ingresar_al_menos_una_tarea_o_item'];
			this.setState({
				errors: errors
			});
		}
		event.preventDefault();

	}

	handleChange(evt, index){
		let formDataCopy = this.state.formData
		formDataCopy.tareas[index].monto = evt.target.value
		this.setState({ formData: formDataCopy });
		this.handleCheckControlTotal(this.state.formData.tareas)
		this.isFormCompleteCheck()
	}

	handleCancel() {
		this.ajaxHandler.unsubscribe();
		this.setState({
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				tareas: []
			},
			listaSelectServicio: [],
			listaSelectTareas: [],
			servicioTareaSeleccionado: null,
			tareasSeleccionadas: [],
			errors: [],
			loading: false,
			tareasDisabled: true,
			tareasIsLoading: false
		 }, ()=>{
			this.props.callbackClose();
		 });
	}

	deleteServicioItem(indexArray){
		let items = [];
		this.state.items.forEach((element, index) => {
			if (index!==indexArray) {
				items.push(element);
			}
		});
		this.calculateTotal(items, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalItems(items)
		this.setState({
			items: items,
		});
  };

	deleteServicioTarea(indexArray){
		let tareas = [];
		this.state.tareas.forEach((element, index) => {
			if (index!==indexArray) {
				tareas.push(element);
			}
		});
		this.calculateTotal(this.state.items, tareas, this.state.formData.impuestos, this.state.formData.otros);
		//this.handleCheckControlTotalItems(items)
		this.setState({
			tareas: tareas,
		});
  };
	
	calculateTotal(items, tareas, impuestosActual, otrosActual, itemsManoDeObra){
		let itemsMdo = itemsManoDeObra ? itemsManoDeObra : this.state.itemsManoDeObra;

		let totalRepuestosNew = 0;
		items.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalRepuestosNew += element.cantidad*element.costo
				}
			}
		});

		let totalManoDeObraItemsNew = 0;
		itemsMdo.forEach(element => {
			if(element.cantidad){
				if(element.costo){
					totalManoDeObraItemsNew += element.cantidad*element.costo
				}
			}
		});

		let totalManoObraNew = 0;
		tareas.forEach(element => {
			if(element.precio){
				totalManoObraNew += element.cantidad*parseFloat(element.precio)
			}
		});

		let totalNew = 0;
		totalNew = totalRepuestosNew + totalManoObraNew + totalManoDeObraItemsNew + parseFloat(impuestosActual) + parseFloat(otrosActual);

		this.setState({
			totalManoDeObra: totalManoObraNew + totalManoDeObraItemsNew,
			totalRepuestos: totalRepuestosNew,
			totalManoDeObraItems: totalManoDeObraItemsNew,
			total: totalNew
		});

	};

	addItem(newServicioItem){
		newServicioItem.cantidad = newServicioItem.cantidad ? newServicioItem.cantidad : 1;
		newServicioItem.costo = newServicioItem.costo ? newServicioItem.costo : 0;
		let copy = JSON.parse(JSON.stringify(this.state.items));
		copy.push(newServicioItem)
		this.calculateTotal(copy, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalItems(copy)
		this.setState({
			items: copy,
		});
  	};

	// VEC-3779: merge por campo PRESENTE. Antes cada update hacía `data.cantidad ? data.cantidad : 1`
	// sobre cualquier payload, pero no todos los payloads son completos: el dropdown de mecánicos llama
	// updateServicioItem({ mecanico_ids: [...] }, index), sin cantidad ni costo. Con la lógica vieja, un
	// click en mecánico reseteaba la cantidad a 1, el costo a 0 y borraba detalle y clasificación.
	// `total` se recalcula siempre desde los valores ya mergeados, no desde el payload parcial.
	// `opciones.claveMonto`: los ítems guardan el monto en 'costo' y las tareas en 'precio'.
	// `opciones.conClasificacion`: solo los ítems la persisten; en tareas la clasificación no existe
	// (el insert de ticket_tareas_cierre ni siquiera tiene la columna).
	mergearCamposFila(fila, data, opciones) {
		let config = opciones || {};
		let campoMonto = config.claveMonto || 'costo';
		if (data.cantidad !== undefined) {
			fila.cantidad = data.cantidad;
		}
		if (data.costo !== undefined) {
			fila[campoMonto] = data.costo;
		}
		if (data.detalle !== undefined) {
			fila.detalle = data.detalle;
		}
		if (config.conClasificacion !== false) {
			if (data.clasificacion !== undefined) {
				fila.clasificacion = data.clasificacion;
			}
			// VEC-3278: el edit modal compartido emite 'id_item_clasificacion'; el cierre mantiene su
			// contrato (setTareasItemsCierre lee 'id_clasificacion'), así que se traduce acá.
			if (data.id_item_clasificacion !== undefined) {
				fila.id_clasificacion = data.id_item_clasificacion;
			}
		}
		if (data.mecanico_ids !== undefined) {
			fila.mecanico_ids = data.mecanico_ids;
		}
		let monto = parseFloat(fila[campoMonto]);
		let cantidad = parseFloat(fila.cantidad);
		fila.total = (isNaN(monto) || isNaN(cantidad)) ? 0 : monto * cantidad;
		return fila;
	}

	updateServicioItem(data, index){
		let copy = JSON.parse(JSON.stringify(this.state.items));
		this.mergearCamposFila(copy[index], data);
		this.calculateTotal(copy, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalItems(copy)
		this.setState({
			items: copy
		});
	}

	handleItemsMOChange(value) {
		this.setState({ itemsMOSeleccionadas: value });
	}

	loadItemsMO(items) {
		let itemsCopy = JSON.parse(JSON.stringify(this.state.itemsManoDeObra));
		items.map((item) => {
			if (itemsCopy.findIndex(x => x.id === item.id && x.servicio.id === item.servicio.id) === -1) {
				itemsCopy.push(item);
			}
			return item;
		});

		this.setState({
			itemsManoDeObra: itemsCopy,
			servicioItemMOSeleccionado: null,
			itemsMOSeleccionadas: [],
			itemsMODisabled: true,
			clasificacionItemMOTemporal: null
		});
		this.calculateTotal(this.state.items, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros, itemsCopy);
		this.handleCheckControlTotalTareas(this.state.tareas, itemsCopy);
	}

	handleAddItemMO() {
		let items = [];
		// VEC-3779: antes la clasificación se hardcodeaba vacía y no había forma de cargarla en el box
		// de Mano de Obra (el de Repuesto sí tenía selector desde siempre).
		let clasificacionMONombre = '';
		let clasificacionMOId = null;
		if (this.state.clasificacionItemMOTemporal) {
			clasificacionMONombre = this.state.clasificacionItemMOTemporal.nombre;
			clasificacionMOId = this.state.clasificacionItemMOTemporal.id;
		}
		this.state.itemsMOSeleccionadas.map((itemSeleccionada) => {
			let item = {
				id: itemSeleccionada.id,
				id_item: itemSeleccionada.id,
				tipo: itemSeleccionada.tipo,
				descripcion: itemSeleccionada.descripcion,
				detalle: '',
				clasificacion: clasificacionMONombre,
				id_clasificacion: clasificacionMOId,
				costo_fijo: itemSeleccionada.costo_fijo,
				servicio: {
					id: this.state.servicioItemMOSeleccionado.value,
					nombre: this.state.servicioItemMOSeleccionado.label
				},
				costo: itemSeleccionada.costo ? itemSeleccionada.costo : 0,
				cantidad: itemSeleccionada.cantidad ? itemSeleccionada.cantidad : 0,
				total: 0
			};
			item.total = item.costo * item.cantidad;
			items.push(item);
			return itemSeleccionada;
		});
		this.loadItemsMO(items);
	}

	deleteItemMO(indexArray) {
		let items = [];
		this.state.itemsManoDeObra.forEach((element, index) => {
			if (index !== indexArray) {
				items.push(element);
			}
		});
		this.calculateTotal(this.state.items, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros, items);
		this.handleCheckControlTotalTareas(this.state.tareas, items);
		this.setState({
			itemsManoDeObra: items
		});
	}

	addItemMOFromGrid(newItem) {
		newItem.cantidad = newItem.cantidad ? newItem.cantidad : 1;
		newItem.costo = newItem.costo ? newItem.costo : 0;
		let copy = JSON.parse(JSON.stringify(this.state.itemsManoDeObra));
		copy.push(newItem);
		this.calculateTotal(this.state.items, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros, copy);
		this.setState({
			itemsManoDeObra: copy
		});
	}

	updateItemMO(data, index) {
		let copy = JSON.parse(JSON.stringify(this.state.itemsManoDeObra));
		// VEC-3779: además del merge por campo presente, ahora persiste la clasificación — antes se
		// descartaba, así que editarla desde el modal no guardaba nada (updateServicioItem sí la copiaba).
		this.mergearCamposFila(copy[index], data);
		this.calculateTotal(this.state.items, this.state.tareas, this.state.formData.impuestos, this.state.formData.otros, copy);
		this.handleCheckControlTotalTareas(this.state.tareas, copy);
		this.setState({
			itemsManoDeObra: copy
		});
	}

	// VEC-3779 (VEC-3149): con trabajaConManoDeObra las clasificaciones están separadas por tipo de ítem
	// (tipoItem=1 Repuesto, tipoItem=2 Mano de Obra). Traer la lista sin filtrar ofrecía clasificaciones
	// de Repuesto en el box de Mano de Obra y viceversa, y esa asignación incorrecta se persistía en
	// ticket_items_cierre.item_clasificacion_id. Sin el flag hay una sola lista, como antes.
	getClasificaciones() {
		let component = this;
		if (this.state.trabajaConManoDeObra) {
			Promise.all([
				this.ajaxHandler.getJson('/item/clasificaciones?tipoItem=1'),
				this.ajaxHandler.getJson('/item/clasificaciones?tipoItem=2')
			])
			.then((results) => {
				let repuesto = results[0] && results[0].clasificaciones ? results[0].clasificaciones : [];
				let manoDeObra = results[1] && results[1].clasificaciones ? results[1].clasificaciones : [];
				component.setState({
					clasificaciones: repuesto,
					clasificacionesManoObra: manoDeObra
				});
			})
			.catch(function(error) {
				component.ajaxHandler.handleError(error);
				component.setState({
					clasificaciones: [],
					clasificacionesManoObra: []
				});
			});
			return;
		}

		this.ajaxHandler.getJson('/item/clasificaciones')
		.then((data) => {
			if(data && data.clasificaciones) {
				component.setState({
					clasificaciones: data.clasificaciones
				});
			}
		})
		.catch(function(error) {
			component.ajaxHandler.handleError(error);
			component.setState({
				clasificaciones: []
			});
		});
	}

	updateTarea(data, index){
		let copy = JSON.parse(JSON.stringify(this.state.tareas));
		// VEC-3779: merge por campo presente (el dropdown de mecánicos manda solo mecanico_ids y antes
		// reseteaba cantidad y precio). La clasificación NO se toca: no aplica a tareas.
		this.mergearCamposFila(copy[index], data, { claveMonto: 'precio', conClasificacion: false });
		this.calculateTotal(this.state.items, copy, this.state.formData.impuestos, this.state.formData.otros);
		this.handleCheckControlTotalTareas(copy)
		this.setState({
			tareas: copy
		});
	}

	setLoadingAndUpdate(state){
		this.setState({ loading: state });
	}

	handleFormChangeImpuestos(value){
		let impuestos = value ? value : 0;
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.impuestos = impuestos;
		this.calculateTotal(this.state.items, this.state.tareas, impuestos, this.state.formData.otros);
		let checkImpuestos = this.props.ticket.impuestos < impuestos
		this.setState({
			formData: formDataCopy,
			maxLimitImpuestos: checkImpuestos
		});
	}

	handleFormChangeOtros(value){
		let otros = value ? value : 0;
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.otros = otros;
		this.calculateTotal(this.state.items, this.state.tareas, this.state.formData.impuestos, otros);
		let checkOtros = this.props.ticket.otros < otros
		this.setState({
			formData: formDataCopy,
			maxLimitOtros: checkOtros
		});
	}

	render() {
		// Filtrar campos de montos si montosRepuesto es false (VEC-3779: la lógica vive en
		// getShowCierreFiltrado para que la validación use exactamente la misma lista que se renderiza).
		let showCierreTareasFiltered = this.getShowCierreFiltrado('tareas');
		let showCierreItemsFiltered = this.getShowCierreFiltrado('items');

		// VEC-3779: con la clasificación obligatoria y visible, no se puede agregar la fila sin elegirla
		// (mismo criterio que PresupuestoDetalladoItem.validate() en la carga del presupuesto).
		let clasificacionRequeridaAlAgregar =
			this.getObligatoriosCierre('items').indexOf('clasificacion') !== -1;

		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
				{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
			</div>
						<form className="form form-horizontal" ref="form" onSubmit={this.handleModalCheck}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section mt-2">
												<i className="la la-cog"></i>
												{this.state.trabajaConManoDeObra
													? <FormattedMessage id="Mano_de_Obra" defaultMessage="Mano De Obra"/>
													: <FormattedMessage id="ticketTareasCierre.render.tareas.header_tareas" defaultMessage=" Tareas"/>
												}
											</h4>
											<div className="row">
												{/* SERVICIO */}
												<div className="col-md-5">
													<div className="form-group row">
														<label className="col-md-4 label-control col-form-label" htmlFor="servicio">
															<FormattedMessage id="ticketTareasCierre.render.tareas.label_servicio" defaultMessage="Servicio:"/>
														</label>
														<div className="col-md-8">
															<div>
																<Select
																	id={this.state.trabajaConManoDeObra ? "servicioItemMO" : "servicioTarea"}
																	name={this.state.trabajaConManoDeObra ? "servicioItemMO" : "servicioTarea"}
																	placeholder={this.props.intl.formatMessage({ id: 'ticketTareasCierre.render.tareas.placeholder_servicio', defaultMessage: 'Servicio' })}
																	options={this.state.servicios}
																	valueKey='value'
																	labelKey='label'
																	value={this.state.trabajaConManoDeObra ? this.state.servicioItemMOSeleccionado : this.state.servicioTareaSeleccionado}
																	onChange={(e) => this.handleServicioChange(e, this.state.trabajaConManoDeObra ? 'servicioItemMO' : 'servicioTarea')}
																/>
															</div>
														</div>
													</div>
												</div>
												{/* TAREAS / ITEMS MO */}
												<div className="col-md-5">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor={this.state.trabajaConManoDeObra ? "itemsMOServicio" : "tareasServicio"}>
															{this.state.trabajaConManoDeObra
																? <FormattedMessage id="Mano_de_Obra" defaultMessage="Mano De Obra:"/>
																: <FormattedMessage id="ticketTareasCierre.render.tareas.label_tareas" defaultMessage="Tareas:"/>
															}
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
															null
															) : (
															<div>
																{this.state.trabajaConManoDeObra ? (
																	<Select
																		id="itemsMOServicio"
																		name="itemsMOServicio"
																		placeholder={this.props.intl.formatMessage({ id: 'Mano_de_Obra', defaultMessage: 'Mano De Obra' })}
																		options={this.state.listaSelectItemsMO}
																		valueKey='id'
																		labelKey='descripcion'
																		closeOnSelect={true}
																		multi
																		removeSelected={true}
																		joinValues
																		value={this.state.itemsMOSeleccionadas}
																		disabled={this.state.itemsMODisabled}
																		isLoading={this.state.itemsMOIsLoading}
																		onChange={this.handleItemsMOChange}
																	/>
																) : (
																<Select
																	id="tareasServicio"
																	name="tareasServicio"
																	placeholder={this.props.intl.formatMessage({ id: 'ticketTareasCierre.render.tareas.placeholder_tareas', defaultMessage: 'Tareas' })}
																	options={this.state.listaSelectTareas}
																	valueKey='id'
																	labelKey='nombre'
																	closeOnSelect={true}
																	multi
																	removeSelected={true}
																	joinValues
																	value={this.state.tareasSeleccionadas}
																	disabled={this.state.tareasDisabled}
																	isLoading={this.state.tareasIsLoading}
																	onChange={this.handleTareasChange}
																/>
																)}
															</div>
															)}
														</div>
													</div>
												</div>
												<div className="col-md-2">
													{this.state.trabajaConManoDeObra ? (
														<button
															className="btn btn-icon-add text-center text-fleet"
															onClick={(e) => { this.handleAddItemMO(); e.preventDefault(); }}
															style={{backgroundColor: 'transparent'}}
															disabled={
																!this.state.itemsMOSeleccionadas
																|| this.state.itemsMOSeleccionadas.length == 0
																|| (clasificacionRequeridaAlAgregar && !this.state.clasificacionItemMOTemporal)
															}
														>
															<i className="ft-plus-circle"></i>
														</button>
													) : (
														<button
															className="btn btn-icon-add text-center text-fleet"
															onClick={(e) => { this.handleAddTarea(); e.preventDefault();}}
															style={{backgroundColor: 'transparent'}}
															disabled={!this.state.tareasSeleccionadas || this.state.tareasSeleccionadas.length == 0}
														>
															<i className="ft-plus-circle"></i>
														</button>
													)}
												</div>
												{/* CLASIFICACIÓN (solo Mano de Obra como ítem). El doble gate es lo que
												    impide que este campo aparezca en la rama de TAREAS: con
												    trabajaConManoDeObra OFF este mismo bloque es el de tareas, que no
												    tiene clasificación. */}
												{this.state.trabajaConManoDeObra && this.state.showCierreItems.includes('clasificacion') && (
													<div className="col-md-5">
														<div className="form-group row" style={{ alignItems: 'center' }}>
															<label className="col-md-4 label-control col-form-label" htmlFor="clasificacionItemMO">
																<FormattedMessage id="Presupuesto.Clasificación" defaultMessage="Clasificación:"/>
															</label>
															<div className="col-md-8">
																<Select
																	id="clasificacionItemMO"
																	name="clasificacionItemMO"
																	placeholder={this.props.intl.formatMessage({ id: 'Presupuesto.Clasificación', defaultMessage: 'Clasificación' })}
																	options={this.state.clasificacionesManoObra.map(clas => ({
																		value: clas.id,
																		label: clas.nombre
																	}))}
																	valueKey='value'
																	labelKey='label'
																	value={this.state.clasificacionItemMOTemporal ? {
																		value: this.state.clasificacionItemMOTemporal.id,
																		label: this.state.clasificacionItemMOTemporal.nombre
																	} : null}
																	onChange={(selectedOption) => {
																		this.setState({
																			clasificacionItemMOTemporal: selectedOption ? {
																				id: selectedOption.value,
																				nombre: selectedOption.label
																			} : null
																		});
																	}}
																/>
															</div>
														</div>
													</div>
												)}
											</div>

											{ this.state.montosRepuesto && this.state.maxLimitObra &&
												<div className="row">
													<div className="col-md-12">
														<div className="form-group row">
															<div className="col-md-4"></div>
															<label className="col-md-8 col-form-label" htmlFor="warningManoDeObra" style={{color: "red"}}>
															<FormattedMessage id="TicketTareasItemsCierre.label_warning_mano_de_obra" defaultMessage="La sumatoria de los montos de mano de obra supera el valor presupuestado"/>
																{":  $"}{this.state.formData.manoDeObra}
															</label>
														</div>
													</div>
												</div>
											}

											{this.state.trabajaConManoDeObra ? (
												this.state.enabledItems ?
													<div>
														<PresupuestoDetalladoItemGrid
															intl={this.props.intl}
															presupuestoItems={this.state.itemsManoDeObra}
															loading={(state) => this.setLoadingAndUpdate(state)}
															deleteItem={this.deleteItemMO}
															updateServicioItem={this.updateItemMO}
															showItems={showCierreItemsFiltered}
															tipoItem={ITEM_TIPO_MANO_DE_OBRA}
															clasificaciones={this.state.clasificacionesManoObra}
														/>
														{this.state.montosRepuesto && (
															<div className="row p-1" style={{justifyContent: "right"}}>
																<label className="col-md-2 label-control col-form-label" htmlFor="total_mano_de_obra_items">
																	<FormattedMessage id="Presupuesto.Total_Mano_de_Obra" defaultMessage="Total Mano de Obra"/>:
																</label>
																<div className="col-md-3">
																	<div>
																		<input disabled
																			type="number"
																			className="form-control text-right pr-1"
																			id="total_mano_de_obra_items"
																			name="total_mano_de_obra_items"
																			value={this.state.totalManoDeObraItems}
																		/>
																	</div>
																</div>
															</div>
														)}
													</div>
												: ''
											) : (
												this.state.enabledTareas ?
													<div>
														<PresupuestoDetalladoTareaGrid
															intl={this.props.intl}
															presupuestoTareas={this.state.tareas}
															loading={(state) => this.setLoadingAndUpdate(state)}
															deleteTarea={this.deleteServicioTarea}
															updatePresupuestoTarea={this.updateTarea}
															showTareas={showCierreTareasFiltered}
														/>
														{this.state.montosRepuesto && (
															<div className="row p-1" style={{justifyContent: "right"}}>
																<label className="col-md-2 label-control col-form-label" htmlFor="total_mano_de_obra">
																	<FormattedMessage id="Presupuesto.Total_Mano_de_Obra" defaultMessage="Total Mano de Obra"/>:
																</label>
																<div className="col-md-3">
																	<div>
																		<input disabled
																			type="number"
																			className="form-control text-right pr-1"
																			id="total_mano_de_obra"
																			name="total_mano_de_obra"
																			value={this.state.totalManoDeObra}
																		/>
																	</div>
																</div>
															</div>
														)}
													</div>
												: ''
											)}


										</div>
									</div>
								</div>


								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section mt-2">
												<i className="la la-cog"></i><FormattedMessage id="Repuesto" defaultMessage="Repuesto"/>
											</h4>
											<div className="row">
												{/* SERVICIO */}
												<div className="col-md-5">
													<div className="form-group row">
														<label className="col-md-4 label-control col-form-label" htmlFor="servicio">
															<FormattedMessage id="ticketTareasCierre.render.tareas.label_servicio" defaultMessage="Servicio:"/>
														</label>
														<div className="col-md-8">
															<div>
																<Select
																	id="servicioItem"
																	name="servicioItem"
																	placeholder={this.props.intl.formatMessage({ id: 'ticketTareasCierre.render.tareas.placeholder_servicio', defaultMessage: 'Servicio' })}
																	options={this.state.servicios}
																	valueKey='value'
																	labelKey='label'
																	value={this.state.servicioItemSeleccionado}
																	onChange={(e) => this.handleServicioChange(e, 'servicioItem')}
																/>
															</div>
														</div>
													</div>
												</div>

												{/* REPUESTOS */}
												<div className="col-md-5">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="repuestosServicio">
															<FormattedMessage id="ticketTareasCierre.render.tareas.label_repuestos" defaultMessage="Repuestos:"/>
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
															null
															) : (
															<div>
																<Select
																	id="repuestosServicio"
																	name="repuestosServicio"
																	placeholder={this.props.intl.formatMessage({ id: 'ticketTareasCierre.render.tareas.placeholder_repuestos', defaultMessage: 'Repuestos' })}
																	options={this.state.listaSelectItems}
																	valueKey='id'
																	labelKey='descripcion'
																	closeOnSelect={true}
																	multi
																	removeSelected={true}
																	joinValues
																	value={this.state.itemsSeleccionadas}
																	disabled={this.state.itemsDisabled}
																	isLoading={this.state.itemsIsLoading}
																	onChange={this.handleItemsChange}
																/>
															</div>
															)}
														</div>
													</div>
												</div>
												{/* CLASIFICACIÓN */}
												{this.state.showCierreItems.includes('clasificacion') && (
													<div className="col-md-5">
														<div className="form-group row" style={{ alignItems: 'center' }}>
															<label className="col-md-4 label-control col-form-label" htmlFor="clasificacionItem">
																<FormattedMessage id="Presupuesto.Clasificación" defaultMessage="Clasificación:"/>
															</label>
															<div className="col-md-8">
																<Select
																	id="clasificacionItem"
																	name="clasificacionItem"
																	placeholder={this.props.intl.formatMessage({ id: 'Presupuesto.Clasificación', defaultMessage: 'Clasificación' })}
																	options={this.state.clasificaciones.map(clas => ({
																		value: clas.id,
																		label: clas.nombre
																	}))}
																	valueKey='value'
																	labelKey='label'
																	value={this.state.clasificacionItemTemporal ? {
																		value: this.state.clasificacionItemTemporal.id,
																		label: this.state.clasificacionItemTemporal.nombre
																	} : null}
																	onChange={(selectedOption) => {
																		if(selectedOption) {
																			this.setState({
																				clasificacionItemTemporal: {
																					id: selectedOption.value,
																					nombre: selectedOption.label
																				}
																			});
																		} else {
																			this.setState({
																				clasificacionItemTemporal: null
																			});
																		}
																	}}
																/>
															</div>
														</div>
													</div>
												)}
												{/* DETALLE */}
												{this.state.showCierreItems.includes('detalle') && (
													<div className="col-md-5">
														<div className="form-group row" style={{ alignItems: 'center' }}>
															<label className="col-md-3 label-control col-form-label" htmlFor="detalleItem">
																<FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle:"/>
															</label>
															<div className="col-md-9">
																<TextField
																	id="detalleItem"
																	type="text"
																	placeholder={this.props.intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
																	value={this.state.detalleItemTemporal}
																	onChange={(e) => {
																		const value = e.target.value;
																		if (value.length <= 60) {
																			this.setState({ detalleItemTemporal: value });
																		}
																	}}
																	fullWidth
																	style={{ marginTop: '8px' }}
																	InputProps={{
																		endAdornment: (
																			<InputAdornment position="end" style={{ marginLeft: 'auto' }}>
																				<span style={{ fontSize: '0.75rem', color: '#666' }}>
																					{this.state.detalleItemTemporal ? this.state.detalleItemTemporal.length : 0}/60
																				</span>
																			</InputAdornment>
																		)
																	}}
																	inputProps={{ 
																		maxLength: 60,
																		style: { 
																			overflow: 'auto',
																			whiteSpace: 'nowrap'
																		}
																	}}
																/>
															</div>
														</div>
													</div>
												)}
												<div className="col-md-1">
													<button
														className="btn btn-icon-add text-center text-fleet"
														onClick={(e) => { this.handleAddItem(); e.preventDefault();}}
														style={{backgroundColor: 'transparent'}}
														disabled={
															!this.state.itemsSeleccionadas
															|| this.state.itemsSeleccionadas.length == 0
															|| (clasificacionRequeridaAlAgregar && !this.state.clasificacionItemTemporal)
														}
													>
														<i className="ft-plus-circle"></i>
													</button>
												</div>
											</div>
											{ this.state.montosRepuesto && this.state.maxLimitMonto &&
												<div className="row">
													<div className="col-md-12">
														<div className="form-group row">
															<div className="col-md-4"></div>
															<label className="col-md-8 col-form-label" htmlFor="warningRepuestos" style={{color: "red"}}>
																<FormattedMessage id="TicketTareasItemsCierre.label_warning_repuestos" defaultMessage="La sumatoria de los montos de los repuestos supera el valor presupuestado"/>
																{":  $"}{this.state.formData.repuestos}
															</label>
														</div>
													</div>
												</div>
											}

											{this.state.enabledItems ? 
												<div>
													<PresupuestoDetalladoItemGrid
														intl={this.props.intl}
														presupuestoItems={this.state.items}
														loading={(state) => this.setLoadingAndUpdate(state)}
														deleteItem={this.deleteServicioItem}
														updateServicioItem={this.updateServicioItem}
														showItems={showCierreItemsFiltered}
														clasificaciones={this.state.clasificaciones}
													/>
													{this.state.montosRepuesto && (
														<div className="row p-1" style={{justifyContent: "right"}}>
															<label className="col-md-2 label-control col-form-label" htmlFor="repuestos">
																<FormattedMessage id="Presupuesto.Total_Repuestos" defaultMessage="Total Repuestos"/>:
															</label>
															<div className="col-md-3">
																<div>
																	<input disabled 
																		type="number"
																		className="form-control text-right pr-1"
																		id="total_repuestos"
																		name="total_repuestos"
																		value={this.state.totalRepuestos}
																	/>
																</div>
															</div>
														</div>
													)}
												</div>
												: null
											}

										</div>
									</div>
								</div>

							{this.state.montosRepuesto && (
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="la la-file-text"></i>
											</h4>
												<div className="row">
													<div className="col-md-6">
													</div>
													<div className="col-md-6">
														{ConfigBusiness.get('tickets.presupuesto.impuestos.habilitado')==="true" ?
															<div className="col-md-12">
																<div className="row p-1" style={{justifyContent: "right"}}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="impuestos">
																		<FormattedMessage id="Impuestos" defaultMessage="Impuestos"/> :
																	</label>
																	<div className="col-md-6">
																		<div>
																			<input
																				type="number"
																				className="form-control text-right pr-1"
																				id="impuestos"
																				name="impuestos"
																				value={this.state.formData.impuestos}
																				onChange={(e) => this.handleFormChangeImpuestos(e.target.value)}
																			/>
																		</div>
																	</div>
																</div>
																{ this.state.maxLimitImpuestos &&
																	<div className="form-group row">
																		<div className="col-md-4"></div>
																		<label className="col-md-8 col-form-label" htmlFor="warningImpuestos" style={{color: "red"}}>
																			<FormattedMessage id="TicketTareasItemsCierre.label_warning_impuestos" defaultMessage="El monto de impuestos supera el valor presupuestado"/>
																		</label>
																	</div>
																}
															</div>
														: null}
														{ConfigBusiness.get('tickets.presupuesto.otros.habilitado')==="true" ?
															<div className="col-md-12">
																<div className="row p-1" style={{justifyContent: "right"}}>
																	<label className="col-md-6 label-control col-form-label" htmlFor="otros">
																		<FormattedMessage id="Otros" defaultMessage="Otros"/> :
																	</label>
																	<div className="col-md-6">
																		<div>
																			<input
																				type="number"
																				className="form-control text-right pr-1"
																				id="otros"
																				name="otros"
																				value={this.state.formData.otros}
																				onChange={(e) => this.handleFormChangeOtros(e.target.value)}
																			/>
																		</div>
																	</div>
																</div>
																{ this.state.maxLimitOtros &&
																	<div className="form-group row">
																		<div className="col-md-3"></div>
																		<label className="col-md-9 col-form-label" htmlFor="warningOtros" style={{color: "red"}}>
																			<FormattedMessage id="ticketTareasCierre.render.tareas.label_warning_otros" defaultMessage="El monto de otros supera el valor presupuestado"/>
																		</label>
																	</div>
																}
															</div>
														: null}
														<div className="col-md-12">
															<div className="row p-1" style={{justifyContent: "right"}}>
																<label className="col-md-6 label-control col-form-label" htmlFor="total">
																	<b><FormattedMessage id="Total" defaultMessage="Total"/></b> :
																</label>
																<div className="col-md-6">
																	<div>
																		<input disabled 
																			type="number"
																			className="form-control text-right pr-1"
																			id="total"
																			name="total"
																			value={this.state.total}
																		/>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
										</div>
									</div>
								</div>
							)}

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<div className="text-cd text-right">
												{this.props.action !== 'VIEW' && (
												<button type="submit" className="btn btn-primary mr-1" 
													disabled={
														this.state.loading ||
														(this.state.montosRepuesto && (
															this.state.maxLimitMonto ||
															this.state.maxLimitObra ||
															this.state.maxLimitImpuestos ||
															this.state.maxLimitOtros
														))
													}
												>
													<i className="fa fa-check-circle"></i><FormattedMessage id="ticketTareasCierre.finish_button.guardar" defaultMessage=" Guardar"/>
												</button>
												)}
												<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
													<i className="fa fa-times-circle"></i><FormattedMessage id="ticketTareasCierre.finish_button.cancelar" defaultMessage=" Cancelar"/>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(TicketTareasItemsCierre);
